import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const navigationActivity = defineStyle({
  bg: 'transparent',
  borderRadius: 0,
  display: 'flex',
  flexShrink: 0,
  fontSize: '11px',
  fontWeight: 'semibold',
  justifyContent: 'flex-end',
  lineHeight: '4',
  px: 0,
  textAlign: 'right',
  textTransform: 'none',
  w: '72px',
});

const configurationReference = defineStyle({
  bg: 'entityDirectory.badgeBackground',
  borderRadius: 0,
  color: 'entityDirectory.text',
  fontFamily: 'instrumentSans',
  fontSize: '12px',
  fontWeight: 'normal',
  lineHeight: '24px',
  minH: '24px',
  px: 2,
  textTransform: 'none',
});

const entityStatus = defineStyle({
  flexShrink: 0,
  fontFamily: 'instrumentSans',
  fontSize: '11px',
  fontWeight: 'semibold',
  px: 2.5,
  py: 1.5,
});

export default defineStyleConfig({
  variants: {
    'job-finished': defineStyle({
      bg: 'jobStatus.finishedBackground',
      borderRadius: 0,
      color: 'jobStatus.finishedText',
      fontWeight: 'bold',
      px: 2.5,
      py: 1,
    }),
    'job-danger': defineStyle({
      bg: 'jobStatus.dangerBackground',
      borderRadius: 0,
      color: 'jobStatus.dangerText',
      fontWeight: 'bold',
      px: 2.5,
      py: 1,
    }),
    'job-waiting': defineStyle({
      bg: 'jobStatus.waitingBackground',
      borderRadius: 0,
      color: 'jobStatus.waitingText',
      fontWeight: 'bold',
      px: 2.5,
      py: 1,
    }),
    'job-running': defineStyle({
      bg: 'jobStatus.runningBackground',
      borderRadius: 0,
      color: 'jobStatus.runningText',
      fontWeight: 'bold',
      px: 2.5,
      py: 1,
    }),
    'navigation-meta': defineStyle({
      alignItems: 'center',
      bg: 'texas.burntSienna.500',
      borderRadius: 'full',
      color: 'white',
      display: 'flex',
      fontFamily: 'instrumentSans',
      fontSize: '10px',
      fontWeight: 'bold',
      h: '16px',
      justifyContent: 'center',
      lineHeight: '16px',
      minW: '16px',
      px: 1,
      position: 'absolute',
      right: '-11px',
      top: '-9px',
    }),
    'entity-directory-reference': defineStyle({
      bg: 'entityDirectory.badgeBackground',
      borderRadius: 0,
      color: 'entityDirectory.text',
      fontFamily: 'instrumentSans',
      fontSize: '11px',
      fontWeight: 'semibold',
      lineHeight: '4',
      px: 2,
      py: 0.5,
      textTransform: 'none',
    }),
    'configuration-reference': configurationReference,
    'configuration-reference-selected': defineStyle({
      ...configurationReference,
      bg: 'entityDirectory.raisedSurface',
      fontWeight: 'semibold',
    }),
    'entity-status-active': defineStyle({
      ...entityStatus,
      bg: 'entityDirectory.successBackground',
      color: 'entityDirectory.successText',
    }),
    'entity-status-inactive': defineStyle({
      ...entityStatus,
      bg: 'entityDirectory.archivedBackground',
      color: 'entityDirectory.archivedText',
    }),
    'navigation-attention': defineStyle({
      ...navigationActivity,
      color: 'texas.burntSienna.500',
    }),
    'navigation-muted': defineStyle({
      ...navigationActivity,
      color: 'navigation.contextMuted',
    }),
    'navigation-success': defineStyle({
      ...navigationActivity,
      color: 'green.600',
      _dark: { color: 'green.300' },
    }),
  },
});
